import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Tables } from "@msuite/utils/types";
import { client } from "@/hono";

export function useRemoteFileUrl(file: Tables<"files"> | null) {
	/** Effects */
	const { data: signedUrl, ...rest } = useQuery({
		queryKey: ["remote-file-url", file?.id ?? ""],
		queryFn: async () => {
			if (!file) return null;
			const response = await client.files[":fileId"].$get({
				param: { fileId: file.id },
			});
			const data = await responseHandler(response);
			return data.signedUrl;
		},
		enabled: !!file,
		staleTime: 1000 * 60 * 60, // 5 minutes
	});

	return {
		signedUrl,
		...rest,
	};
}
